import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-catalogue',
  templateUrl: './add-catalogue.component.html',
  styleUrls: ['./add-catalogue.component.scss']
})
export class AddCatalogueComponent implements OnInit {

  roletype: any;

  constructor() { }

  ngOnInit(): void {
  }

  selectRoletype(event){
    this.roletype = event.value
  }

}
